import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-session-lock-screen-with-image',
  templateUrl: './session-lock-screen-with-image.component.html',
  styleUrls: ['./session-lock-screen-with-image.component.scss']
})
export class SessionLockScreenWithImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
